import { useRouter } from 'next/router'
import * as Pages from 'layouts/pages'
import Post from 'layouts/feed/Post'
import * as Blog from '@avcan/prismic/clients/blog'
import * as NextUtils from 'utils/next'

export async function getStaticProps({ params, locale }) {
    const { uid } = params
    const [document, related] = await Promise.all([Blog.get(uid, locale), Blog.getRelated(uid, locale)])

    if (!document) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            document,
            related,
        },
    }
}

export async function getStaticPaths() {
    const { posts } = await Blog.getList()
    const paths = posts.map(NextUtils.createParamsFromPrismicDocument)

    return {
        paths: NextUtils.internationalizeStaticPaths(paths),
        fallback: true,
    }
}

export default function NewsPost(props) {
    const router = useRouter()

    if (router.isFallback) {
        return <Pages.Loading />
    }

    return <Post {...props} />
}
